// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Search2 from "../common/Search2.bs.js";
import * as Tooltip from "common/src/components/Tooltip.bs.js";
import * as ItemName from "common/src/tft-static/ItemName.bs.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as UnitName0 from "common/src/tft-static/UnitName0.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as SearchField2 from "../components/SearchField2.bs.js";
import * as Belt_SetString from "rescript/lib/es6/belt_SetString.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import * as Belt_MutableMapString from "rescript/lib/es6/belt_MutableMapString.js";

function Tc2ItemsTab$ItemStatsTooltip(Props) {
  var count = Props.count;
  var place = Props.place;
  var top4 = Props.top4;
  var won = Props.won;
  var delta = Props.delta;
  var unitId = Props.unitId;
  var itemId = Props.itemId;
  var itemId2 = Props.itemId2;
  var children = Props.children;
  var t = Translation.useT(/* Common */0);
  return React.createElement(Tooltip.make, {
              title: React.createElement("div", {
                    className: "w-[175px]"
                  }, React.createElement("div", {
                        className: "text-sm font-medium font-montserrat leading-snug"
                      }, React.createElement("div", undefined, React.createElement(UnitName0.make, {
                                unit: unitId
                              })), React.createElement("div", undefined, React.createElement(ItemName.make, {
                                itemId: itemId
                              })), itemId2 !== undefined ? React.createElement("div", undefined, React.createElement(ItemName.make, {
                                  itemId: itemId2
                                })) : null), React.createElement("div", {
                        className: "py-2 grid gap-[2px] grid-cols-[60px_60px] text-sm"
                      }, React.createElement("div", undefined, t("Games")), React.createElement("div", undefined, T.humanReadableCount(count)), React.createElement("div", undefined, t("Avg.")), React.createElement("div", undefined, Global.toFixed(undefined, place)), React.createElement("div", undefined, t("Delta") + "*"), React.createElement("div", undefined, Global.toFixed(undefined, delta)), React.createElement("div", undefined, t("Top 4")), React.createElement("div", undefined, Global.formatPct2(undefined, Global.f(top4) / Global.f(count))), React.createElement("div", undefined, t("Won")), React.createElement("div", undefined, Global.formatPct2(undefined, Global.f(won) / Global.f(count)))), React.createElement("div", undefined, "* Delta shows the difference in average placement between unit with the item and unit without the item.")),
              children: children
            });
}

var ItemStatsTooltip = {
  make: Tc2ItemsTab$ItemStatsTooltip
};

function Tc2ItemsTab$Units(Props) {
  var unitItems = Props.unitItems;
  var units = Props.units;
  var totCount = Props.totCount;
  var searchUnits = Props.searchUnits;
  var searchItems = Props.searchItems;
  TftSet.use(undefined);
  Translation.useT(/* Units */1);
  Translation.useT(/* Items */3);
  var grouped = React.useMemo((function () {
          var unitItems$1 = Belt_Array.keep(unitItems, (function (ui) {
                  if (Belt_Option.mapWithDefault(searchUnits, true, (function (searchUnits) {
                            return Belt_SetString.has(searchUnits, ui.unitId);
                          }))) {
                    return true;
                  } else {
                    return Belt_Option.mapWithDefault(searchItems, true, (function (searchItems) {
                                  return Belt_SetString.has(searchItems, ui.itemId);
                                }));
                  }
                }));
          var unitCounts = Belt_MutableMapString.make(undefined);
          Belt_Array.forEach(unitItems$1, (function (ui) {
                  var curr = Belt_MutableMapString.getWithDefault(unitCounts, ui.unitId, 0);
                  return Belt_MutableMapString.set(unitCounts, ui.unitId, curr + ui.count | 0);
                }));
          var topUnits = Belt_Array.map(Belt_SortArray.stableSortBy(Belt_MutableMapString.toArray(unitCounts), (function (param, param$1) {
                      return Caml.caml_int_compare(param$1[1], param[1]);
                    })), (function (prim) {
                  return prim[0];
                }));
          return Belt_Array.map(topUnits, (function (unitId) {
                        return [
                                unitId,
                                Belt_Array.keep(unitItems$1, (function (ui) {
                                        return ui.unitId === unitId;
                                      }))
                              ];
                      }));
        }), [
        unitItems,
        searchUnits,
        searchItems
      ]);
  return React.createElement("div", {
              className: "flex flex-col"
            }, Belt_Array.mapWithIndex(grouped, (function (idx, param) {
                    var unitId = param[0];
                    var match = Belt_Array.reduce(units, [
                          0,
                          0
                        ], (function (acc, param) {
                            if (unitId !== param[0]) {
                              return acc;
                            }
                            var c = param[2];
                            return [
                                    acc[0] + c | 0,
                                    acc[1] + Global.f(c) * param[3]
                                  ];
                          }));
                    var unitCount = match[0];
                    var unitPlace = match[1] / Global.f(unitCount);
                    return React.createElement("div", {
                                key: unitId,
                                className: "flex flex-wrap items-center gap-5 pl-7 py-[14px]" + (
                                  idx % 2 === 0 ? " bg-bg2" : ""
                                )
                              }, React.createElement("div", {
                                    className: "flex flex-col items-center gap-1"
                                  }, React.createElement(UnitImage.make, {
                                        unitId: unitId,
                                        size: 40
                                      }), React.createElement("div", {
                                        className: "pt-[2px]"
                                      }, Global.formatPct2(undefined, Caml.caml_float_min(Global.f(unitCount) / Global.f(totCount), 1))), React.createElement("div", undefined, Global.toFixed(undefined, unitPlace))), Belt_Array.map(Belt_Array.slice(param[1], 0, 10), (function (ui) {
                                      var delta = (ui.place - unitPlace) / (1 - Global.f(ui.count) / Global.f(unitCount));
                                      return React.createElement(Tc2ItemsTab$ItemStatsTooltip, {
                                                  count: ui.count,
                                                  place: ui.place,
                                                  top4: ui.top4,
                                                  won: ui.won,
                                                  delta: delta,
                                                  unitId: ui.unitId,
                                                  itemId: ui.itemId,
                                                  children: React.createElement("div", {
                                                        className: "flex flex-col items-center gap-1 pt-1 w-[39px]"
                                                      }, React.createElement(ItemImage.make, {
                                                            itemId: ui.itemId,
                                                            size: 36,
                                                            rounded: "rounded"
                                                          }), React.createElement("div", {
                                                            className: "pt-[2px]"
                                                          }, Global.formatPct2(undefined, Global.f(ui.count) / Global.f(unitCount))), React.createElement("div", undefined, Global.toFixed(undefined, ui.place)), React.createElement("div", {
                                                            className: "mx-[-2px]"
                                                          }, "(" + Global.toFixedSign(undefined, delta) + ")"))
                                                });
                                    })));
                  })));
}

var Units = {
  make: Tc2ItemsTab$Units
};

function Tc2ItemsTab$ItemPairs(Props) {
  var unitItemPairs = Props.unitItemPairs;
  var units = Props.units;
  var totCount = Props.totCount;
  var searchUnits = Props.searchUnits;
  var searchItems = Props.searchItems;
  TftSet.use(undefined);
  Translation.useT(/* Units */1);
  Translation.useT(/* Items */3);
  var grouped = React.useMemo((function () {
          var unitItemPairs$1 = Belt_Array.keep(unitItemPairs, (function (ui) {
                  if (Belt_Option.mapWithDefault(searchUnits, true, (function (searchUnits) {
                            return Belt_SetString.has(searchUnits, ui.unitId);
                          })) || Belt_Option.mapWithDefault(searchItems, true, (function (searchItems) {
                            return Belt_SetString.has(searchItems, Belt_Array.getExn(ui.items, 0));
                          }))) {
                    return true;
                  } else {
                    return Belt_Option.mapWithDefault(searchItems, true, (function (searchItems) {
                                  return Belt_SetString.has(searchItems, Belt_Array.getExn(ui.items, 1));
                                }));
                  }
                }));
          var unitCounts = Belt_MutableMapString.make(undefined);
          Belt_Array.forEach(unitItemPairs$1, (function (ui) {
                  var curr = Belt_MutableMapString.getWithDefault(unitCounts, ui.unitId, 0);
                  return Belt_MutableMapString.set(unitCounts, ui.unitId, curr + ui.count | 0);
                }));
          var topUnits = Belt_Array.map(Belt_SortArray.stableSortBy(Belt_MutableMapString.toArray(unitCounts), (function (param, param$1) {
                      return Caml.caml_int_compare(param$1[1], param[1]);
                    })), (function (prim) {
                  return prim[0];
                }));
          return Belt_Array.map(topUnits, (function (unitId) {
                        return [
                                unitId,
                                Belt_Array.keep(unitItemPairs$1, (function (ui) {
                                        return ui.unitId === unitId;
                                      }))
                              ];
                      }));
        }), [
        unitItemPairs,
        searchUnits,
        searchItems
      ]);
  return React.createElement("div", {
              className: "flex flex-col"
            }, Belt_Array.mapWithIndex(grouped, (function (idx, param) {
                    var unitId = param[0];
                    var match = Belt_Array.reduce(units, [
                          0,
                          0
                        ], (function (acc, param) {
                            if (unitId !== param[0]) {
                              return acc;
                            }
                            var c = param[2];
                            return [
                                    acc[0] + c | 0,
                                    acc[1] + Global.f(c) * param[3]
                                  ];
                          }));
                    var unitCount = match[0];
                    var unitPlace = match[1] / Global.f(unitCount);
                    return React.createElement("div", {
                                key: unitId,
                                className: "flex flex-wrap items-center pl-7 gap-5 py-[14px]" + (
                                  idx % 2 === 0 ? " bg-bg2" : ""
                                )
                              }, React.createElement("div", {
                                    className: "flex flex-col items-center gap-2"
                                  }, React.createElement(UnitImage.make, {
                                        unitId: unitId,
                                        size: 40
                                      }), React.createElement("div", undefined, Global.formatPct2(undefined, Caml.caml_float_min(Global.f(unitCount) / Global.f(totCount), 1))), React.createElement("div", undefined, Global.toFixed(undefined, unitPlace))), Belt_Array.mapWithIndex(Belt_Array.slice(param[1], 0, 10), (function (idx, uip) {
                                      var delta = (uip.place - unitPlace) / (1 - Global.f(uip.count) / Global.f(unitCount));
                                      var tmp = {
                                        count: uip.count,
                                        place: uip.place,
                                        top4: uip.top4,
                                        won: uip.won,
                                        delta: delta,
                                        unitId: uip.unitId,
                                        itemId: Belt_Array.getExn(uip.items, 0),
                                        children: React.createElement("div", {
                                              className: "flex flex-col items-center gap-[6px] w-[39px]"
                                            }, Belt_Array.map(uip.items, (function (itemId) {
                                                    return React.createElement(ItemImage.make, {
                                                                itemId: itemId,
                                                                size: 36,
                                                                rounded: "rounded",
                                                                key: String(idx)
                                                              });
                                                  })), React.createElement("div", undefined, Global.formatPct2(undefined, Global.f(uip.count) / Global.f(unitCount))), React.createElement("div", undefined, Global.toFixed(undefined, uip.place)), React.createElement("div", {
                                                  className: "mx-[-2px]"
                                                }, "(" + Global.toFixedSign(undefined, delta) + ")"))
                                      };
                                      var tmp$1 = Belt_Array.get(uip.items, 1);
                                      if (tmp$1 !== undefined) {
                                        tmp.itemId2 = Caml_option.valFromOption(tmp$1);
                                      }
                                      return React.createElement(Tc2ItemsTab$ItemStatsTooltip, tmp);
                                    })));
                  })));
}

var ItemPairs = {
  make: Tc2ItemsTab$ItemPairs
};

function Tc2ItemsTab$Items(Props) {
  var unitItems = Props.unitItems;
  var generalItems = Props.generalItems;
  var totCount = Props.totCount;
  var units = Props.units;
  var searchUnits = Props.searchUnits;
  var searchItems = Props.searchItems;
  var set = TftSet.use(undefined);
  Translation.useT(/* Units */1);
  Translation.useT(/* Items */3);
  var grouped = React.useMemo((function () {
          var unitItems$1 = Belt_Array.keep(unitItems, (function (ui) {
                  if (Belt_Option.mapWithDefault(searchUnits, true, (function (searchUnits) {
                            return Belt_SetString.has(searchUnits, ui.unitId);
                          }))) {
                    return true;
                  } else {
                    return Belt_Option.mapWithDefault(searchItems, true, (function (searchItems) {
                                  return Belt_SetString.has(searchItems, ui.itemId);
                                }));
                  }
                }));
          var itemCounts = Belt_MutableMapString.make(undefined);
          Belt_Array.forEach(unitItems$1, (function (ui) {
                  var curr = Belt_MutableMapString.getWithDefault(itemCounts, ui.itemId, 0);
                  return Belt_MutableMapString.set(itemCounts, ui.itemId, curr + ui.count | 0);
                }));
          var topItems = Belt_Array.map(Belt_SortArray.stableSortBy(Belt_MutableMapString.toArray(itemCounts), (function (param, param$1) {
                      return Caml.caml_int_compare(param$1[1], param[1]);
                    })), (function (prim) {
                  return prim[0];
                }));
          return Belt_Array.map(topItems, (function (itemId) {
                        return [
                                itemId,
                                Belt_Array.keep(unitItems$1, (function (ui) {
                                        return ui.itemId === itemId;
                                      }))
                              ];
                      }));
        }), [
        unitItems,
        searchUnits,
        searchItems
      ]);
  var craftableItems = Belt_Array.keep(grouped, (function (param) {
          return Belt_Option.getExn(Js_dict.get(Data.items(set), param[0])).id < 45;
        }));
  var nonCraftableItems = Belt_Array.keep(grouped, (function (param) {
          return Belt_Option.getExn(Js_dict.get(Data.items(set), param[0])).id >= 45;
        }));
  var maxLen = Caml.caml_int_max(craftableItems.length, nonCraftableItems.length);
  return React.createElement("div", {
              className: "flex justify-between w-full"
            }, React.createElement("div", {
                  className: "flex flex-col w-full"
                }, Belt_Array.map(Belt_Array.range(0, maxLen - 1 | 0), (function (idx) {
                        var item = Belt_Array.get(craftableItems, idx);
                        var tmp;
                        if (item !== undefined) {
                          var itemId = item[0];
                          var gi = generalItems.find(function (param) {
                                return itemId === param[0];
                              });
                          tmp = React.createElement(React.Fragment, undefined, React.createElement("div", {
                                    className: "flex flex-col items-center gap-[6px]"
                                  }, React.createElement(ItemImage.make, {
                                        itemId: itemId,
                                        size: 40,
                                        rounded: "rounded"
                                      }), gi !== undefined ? React.createElement(React.Fragment, undefined, React.createElement("div", undefined, Global.formatPct2(undefined, Global.f(gi[1]) / Global.f(totCount))), React.createElement("div", undefined, Global.toFixed(undefined, gi[2]))) : null), Belt_Array.map(Belt_Array.slice(item[1], 0, 5), (function (ui) {
                                      var match = Belt_Array.reduce(units, [
                                            0,
                                            0
                                          ], (function (acc, param) {
                                              var c = param[2];
                                              if (ui.unitId === param[0]) {
                                                return [
                                                        acc[0] + c | 0,
                                                        acc[1] + Global.f(c) * param[3]
                                                      ];
                                              } else {
                                                return acc;
                                              }
                                            }));
                                      var unitCount = match[0];
                                      var unitPlace = match[1] / Global.f(unitCount);
                                      var delta = (ui.place - unitPlace) / (1 - Global.f(ui.count) / Global.f(unitCount));
                                      return React.createElement(Tc2ItemsTab$ItemStatsTooltip, {
                                                  count: ui.count,
                                                  place: ui.place,
                                                  top4: ui.top4,
                                                  won: ui.won,
                                                  delta: delta,
                                                  unitId: ui.unitId,
                                                  itemId: ui.itemId,
                                                  children: React.createElement("div", {
                                                        className: "flex flex-col items-center gap-[6px] w-[40px] pt-1"
                                                      }, React.createElement(UnitImage.make, {
                                                            unitId: ui.unitId,
                                                            size: 36
                                                          }), React.createElement("div", undefined, gi !== undefined ? Global.formatPct2(undefined, Global.f(ui.count) / Global.f(gi[1])) : T.humanReadableCount(ui.count)), React.createElement("div", undefined, Global.toFixed(undefined, ui.place)), React.createElement("div", {
                                                            className: "mx-[-2px]"
                                                          }, "(" + Global.toFixedSign(undefined, delta) + ")"))
                                                });
                                    })));
                        } else {
                          tmp = null;
                        }
                        var item$1 = Belt_Array.get(nonCraftableItems, idx);
                        var tmp$1;
                        if (item$1 !== undefined) {
                          var itemId$1 = item$1[0];
                          var gi$1 = generalItems.find(function (param) {
                                return itemId$1 === param[0];
                              });
                          tmp$1 = React.createElement(React.Fragment, undefined, React.createElement("div", {
                                    className: "flex flex-col items-center gap-[6px]"
                                  }, React.createElement(ItemImage.make, {
                                        itemId: itemId$1,
                                        size: 40,
                                        rounded: "rounded"
                                      }), gi$1 !== undefined ? React.createElement(React.Fragment, undefined, React.createElement("div", undefined, Global.formatPct2(undefined, Global.f(gi$1[1]) / Global.f(totCount))), React.createElement("div", undefined, Global.toFixed(undefined, gi$1[2]))) : null), Belt_Array.map(Belt_Array.slice(item$1[1], 0, 4), (function (ui) {
                                      var match = Belt_Array.reduce(units, [
                                            0,
                                            0
                                          ], (function (acc, param) {
                                              var c = param[2];
                                              if (ui.unitId === param[0]) {
                                                return [
                                                        acc[0] + c | 0,
                                                        acc[1] + Global.f(c) * param[3]
                                                      ];
                                              } else {
                                                return acc;
                                              }
                                            }));
                                      var unitCount = match[0];
                                      var unitPlace = match[1] / Global.f(unitCount);
                                      var delta = (ui.place - unitPlace) / (1 - Global.f(ui.count) / Global.f(unitCount));
                                      return React.createElement(Tc2ItemsTab$ItemStatsTooltip, {
                                                  count: ui.count,
                                                  place: ui.place,
                                                  top4: ui.top4,
                                                  won: ui.won,
                                                  delta: delta,
                                                  unitId: ui.unitId,
                                                  itemId: ui.itemId,
                                                  children: React.createElement("div", {
                                                        className: "flex flex-col items-center gap-[6px] pt-1 w-[40px]"
                                                      }, React.createElement(UnitImage.make, {
                                                            unitId: ui.unitId,
                                                            size: 36
                                                          }), React.createElement("div", undefined, gi$1 !== undefined ? Global.formatPct2(undefined, Global.f(ui.count) / Global.f(gi$1[1])) : T.humanReadableCount(ui.count)), React.createElement("div", undefined, Global.toFixed(undefined, ui.place)), React.createElement("div", {
                                                            className: "mx-[-2px]"
                                                          }, "(" + Global.toFixedSign(undefined, delta) + ")"))
                                                });
                                    })));
                        } else {
                          tmp$1 = null;
                        }
                        return React.createElement("div", {
                                    key: String(idx),
                                    className: "flex flex-col gap-5 md:gap-0 md:flex-row w-full px-7 pr-[22px] py-5 md:py-[14px]" + (
                                      idx % 2 === 0 ? " bg-bg2" : ""
                                    )
                                  }, React.createElement("div", {
                                        className: "flex gap-4 md:w-[58%]"
                                      }, tmp), React.createElement("div", {
                                        className: "flex flex-wrap gap-4 md:w-[42%]"
                                      }, tmp$1));
                      }))));
}

var Items = {
  make: Tc2ItemsTab$Items
};

function Tc2ItemsTab(Props) {
  var group = Props.group;
  var set = TftSet.use(undefined);
  var t = Translation.useT(/* Common */0);
  var match = React.useState(function () {
        return /* Units2 */0;
      });
  var setTab = match[1];
  var tab = match[0];
  var match$1 = React.useState(function () {
        return "";
      });
  var search = match$1[0];
  var searchUnits = React.useMemo((function () {
          if (search === "") {
            return ;
          } else {
            return Caml_option.some(Belt_SetString.fromArray(Search2.searchUnitsExactArr(search, set)));
          }
        }), [search]);
  var searchItems = React.useMemo((function () {
          if (search === "") {
            return ;
          } else {
            return Caml_option.some(Belt_SetString.fromArray(Search2.searchItemsArr(search, set)));
          }
        }), [search]);
  var tmp;
  switch (tab) {
    case /* Units2 */0 :
        tmp = React.createElement(Tc2ItemsTab$Units, {
              unitItems: group.unitItems,
              units: group.units,
              totCount: group.count,
              searchUnits: searchUnits,
              searchItems: searchItems
            });
        break;
    case /* Items2 */1 :
        tmp = React.createElement(Tc2ItemsTab$Items, {
              unitItems: group.unitItems,
              generalItems: group.generalItems,
              totCount: group.count,
              units: group.units,
              searchUnits: searchUnits,
              searchItems: searchItems
            });
        break;
    case /* ItemPairs */2 :
        tmp = React.createElement(Tc2ItemsTab$ItemPairs, {
              unitItemPairs: group.unitItemPairs,
              units: group.units,
              totCount: group.count,
              searchUnits: searchUnits,
              searchItems: searchItems
            });
        break;
    
  }
  return React.createElement("div", {
              className: "text-[13px] leading-none"
            }, React.createElement("div", {
                  className: "pb-5 flex flex-col gap-2 sm:gap-4 sm:flex-row sm:justify-between"
                }, React.createElement(Tabs, {
                      children: null,
                      value: tab,
                      onChange: (function (param, t) {
                          return Curry._1(setTab, (function (param) {
                                        return t;
                                      }));
                        })
                    }, React.createElement(Tab, {
                          label: t("By Units"),
                          value: /* Units2 */0
                        }), React.createElement(Tab, {
                          label: t("Item Pairs"),
                          value: /* ItemPairs */2
                        }), React.createElement(Tab, {
                          label: t("By Items"),
                          value: /* Items2 */1
                        })), React.createElement("div", {
                      className: "w-[200px]"
                    }, React.createElement(SearchField2.make, {
                          search: search,
                          setSearch: match$1[1]
                        }))), React.createElement("div", {
                  className: "mx-[-20px]"
                }, tmp));
}

var make = Tc2ItemsTab;

export {
  ItemStatsTooltip ,
  Units ,
  ItemPairs ,
  Items ,
  make ,
  
}
/* T Not a pure module */
